export const API_CONFIG = {
    BASE_URL: 'https://travel-agency-server-lilac.vercel.app/api',
    TIMEOUT: 30000
};

// Enhanced API helper with better error handling
export const apiRequest = async (endpoint, options = {}) => {
    const url = `${API_CONFIG.BASE_URL}${endpoint}`;

    const defaultOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
    };

    const config = {
        ...defaultOptions,
        ...options,
        headers: {
            ...defaultOptions.headers,
            ...options.headers,
        },
    };

    // Get token from localStorage
    const token = localStorage.getItem('userToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    // Stringify body if it's an object
    if (config.body && typeof config.body === 'object') {
        config.body = JSON.stringify(config.body);
    }

    console.log(`🔄 Making API request to: ${url}`);
    console.log(`📋 Request config:`, {
        method: config.method,
        headers: config.headers,
        hasBody: !!config.body,
        hasToken: !!token
    });

    try {
        const response = await fetch(url, config);

        console.log(`📨 Response status: ${response.status} ${response.statusText}`);

        if (response.status === 401) {
            // Token expired or invalid
            localStorage.removeItem('userToken');
            throw new Error('Authentication failed. Please sign in again.');
        }

        if (!response.ok) {
            let errorData;
            try {
                errorData = await response.json();
            } catch (e) {
                errorData = { error: await response.text() };
            }

            throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log(`✅ API Success: ${config.method} ${url}`);
        return data;

    } catch (error) {
        console.error(`🚨 API Request failed for ${url}:`, error);

        if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
            throw new Error(`
❌ Network Connection Failed!

Possible reasons:
1. Server is not running - Make sure backend server is started
2. Wrong port - Check if server is running on port 3001
3. Firewall blocking - Check firewall settings

💡 Solutions:
• Run: cd travel-agency-server && npm start
• Check: https://travel-agency-server-lilac.vercel.app/
• Verify server is running on port 3001
            `);
        }

        throw error;
    }
};

// Specific API methods
export const api = {
    get: (endpoint) => apiRequest(endpoint),

    post: (endpoint, data) => apiRequest(endpoint, {
        method: 'POST',
        body: JSON.stringify(data)
    }),

    put: (endpoint, data) => apiRequest(endpoint, {
        method: 'PUT',
        body: JSON.stringify(data)
    }),

    delete: (endpoint) => apiRequest(endpoint, {
        method: 'DELETE'
    })
};